<template>
	<v-row no-gutters justify="center">
		<!-- <v-btn x-small fab class="mx-1" color="white">
      <v-icon>mdi-chevron-left</v-icon>
		</v-btn>-->
		<v-btn
			x-small
			fab
			depressed
			class="mx-1"
			:color="letter == 'no-filter' ? 'primary' : ''"
			@click="letter = 'no-filter'"
		>
			<v-icon>mdi-alphabetical-variant</v-icon>
		</v-btn>
		<v-btn
			v-for="l in letters"
			@click="letter = l.value"
			depressed
			x-small
			fab
			class="mx-1"
			:color="letter == l.value ? 'primary' : ''"
			:key="l.text"
		>{{l.text}}</v-btn>
		<!-- <v-btn x-small fab class="mx-1" color="white">
      <v-icon>mdi-chevron-right</v-icon>
		</v-btn>-->
	</v-row>
</template>

<script>
export default {
	name: "AlphabeticFilter",
	data: () => ({
		letters: [
			{ text: "A", value: "a" },
			{ text: "B", value: "b" },
			{ text: "C", value: "c" },
			{ text: "D", value: "d" },
			{ text: "E", value: "e" },
			{ text: "F", value: "f" },
			{ text: "G", value: "g" },
			{ text: "H", value: "h" },
			{ text: "I", value: "i" },
			{ text: "J", value: "j" },
			{ text: "K", value: "k" },
			{ text: "L", value: "l" },
			{ text: "M", value: "m" },
			{ text: "N", value: "n" },
			{ text: "O", value: "o" },
			{ text: "P", value: "p" },
			{ text: "Q", value: "q" },
			{ text: "R", value: "r" },
			{ text: "S", value: "s" },
			{ text: "T", value: "t" },
			{ text: "U", value: "u" },
			{ text: "V", value: "v" },
			{ text: "W", value: "w" },
			{ text: "X", value: "x" },
			{ text: "Y", value: "y" },
			{ text: "Z", value: "z" }
		],
		letter: "no-filter"
	}),
	methods: {
		getLetter() {
			return this.letter;
		}
	}
};
</script>